"use client";

import createCache from "@emotion/cache";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v14-appRouter";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import rtlPlugin from "stylis-plugin-rtl";
import theme from "./theme";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [rtlPlugin],
});

const ThemeProviders = ({ children }: { children: React.ReactNode }) => (
  <AppRouterCacheProvider options={{ ...cacheRtl, enableCssLayer: true }}>
    <ThemeProvider theme={theme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      {children}
    </ThemeProvider>
  </AppRouterCacheProvider>
);

export default ThemeProviders;
